import { defineStore } from 'pinia';
import type { Brand, BrandConfigs, BrandConfig } from '@/config/brand.config';

export const useBrandStore = defineStore('brand', () => {
  const brandConfig = ref<BrandConfig>({} as BrandConfig);
  const brand = ref<Brand>('dahl');

  const fetchConfig = async (b: Brand) => {
    const result = await $fetch<BrandConfigs>('/api/brand-config');

    brand.value = b;
    brandConfig.value = result[brand.value];
  };

  return {
    brand,
    brandConfig,
    fetchConfig,
  };
});
